// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu--2-Zkp","dropDown":"dropDown--1f8Dw","languageSpinner":"languageSpinner--2imjx"};